<template>
  <InvoiceParameterDefaultModal
    title="Status da Regra"
    width="400"
    showOctagon
    :show="show"
    @close="$emit('confirm', false)">
    <template slot="body">
      <div>
        <TextBase>
          Você está prestes a {{label}} esta regra.
        </TextBase>
        <TextBase>
          Deseja continuar?
        </TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined
          @click="$emit('confirm', false)">
          Cancelar
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="$emit('confirm', true)">
          Confirmar
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
export default {
  name: "RuleStatusConfirmationModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText,
  },
  props: {
    label: {
      type: String,
      default: 'ativar',
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>